import UbahSOSPK from './UbahSOSPK';

export default UbahSOSPK